import { EditorUtils } from "@progress/kendo-react-editor"
import { Button } from "@progress/kendo-react-buttons"
import { SvgIcon } from "@progress/kendo-react-common"
import { equalIcon } from "@progress/kendo-svg-icons"

const OrderedListTool = (props) => {
    const { view } = props
    const nodeType = view && view.state.schema.nodes.text
    const canInsert = view && EditorUtils.canInsert(view.state, nodeType)

    const styleListItem = () => {
        const { view } = props

        EditorUtils.applyInlineStyle(view, {
            style: "treat-as-li",
            value: "true"
        })

        EditorUtils.applyInlineStyle(view, {
            style: "background-color",
            value: "#c0e2f5"
        })

        //EditorUtils.removeAttribute()
    }

    return (
        <Button
            onClick={styleListItem}
            onMouseDown={(e) => e.preventDefault()}
            onPointerDown={(e) => e.preventDefault()}
            title="Hanging Indent List Item"
            svgIcon={equalIcon}
        />
    )
}

export default OrderedListTool
